import { useEffect, useState } from "react";
import { BRAND } from "../content/site";
import { openWA, KISS } from "../lib/wa";

const links = [
  { href: "#about", label: "About" },
  { href: "#gallery", label: "Gallery" },
  { href: "#rates", label: "Rates" },
  { href: "#booking", label: "Book" },
  { href: "#onlyfans", label: "OnlyFans" },
  { href: "#faq", label: "FAQ" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`sticky top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-[rgba(10,10,10,0.75)] backdrop-blur-md border-b border-[rgba(201,169,97,0.15)]"
          : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between py-4 md:py-5 px-5 md:px-8">
        <a
          href="#top"
          className="font-display text-2xl md:text-3xl text-gold tracking-wide"
          data-testid="nav-brand"
        >
          {BRAND.siteTitle}
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="nav-link"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            className="btn-gold hidden md:inline-flex"
            onClick={() => {
              try { require("../lib/analytics").trackWa("nav_button"); } catch {}
              openWA(
                `Hi Camilla ${KISS} — I found you on your site and want to say hi.`
              );
            }}
            data-testid="nav-wa-btn"
          >
            WhatsApp
          </button>
          <a
            href="/admin"
            className="nav-admin-btn hidden md:inline-flex"
            data-testid="nav-admin-btn"
          >
            Admin
          </a>
          <button
            className="lg:hidden text-gold p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="nav-menu-toggle"
          >
            <div className="w-6 h-[1.5px] bg-current mb-1.5" />
            <div className="w-6 h-[1.5px] bg-current mb-1.5" />
            <div className="w-4 h-[1.5px] bg-current" />
          </button>
        </div>
      </div>

      {open && (
        <div
          className="lg:hidden bg-[rgba(6,6,6,0.98)] border-t border-[rgba(201,169,97,0.15)]"
          data-testid="nav-mobile-menu"
        >
          <div className="container-x px-5 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="nav-link"
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <button
              className="btn-gold mt-2 self-start"
              onClick={() => {
                setOpen(false);
                openWA(`Hi Camilla ${KISS}`);
              }}
              data-testid="mobile-nav-wa-btn"
            >
              WhatsApp me
            </button>
            <a
              href="/admin"
              onClick={() => setOpen(false)}
              className="nav-admin-btn self-start"
              data-testid="mobile-nav-admin-btn"
            >
              Admin
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
